import * as React from "react";
import type { SidebarLayoutMode } from "@/utils/hooks/useBreakpoint";

type AppShellContextValue = {
    mobileSidebarOpen: boolean;
    setMobileSidebarOpen: (open: boolean) => void;
    sidebarCollapsed: boolean;
    setSidebarCollapsed: (collapsed: boolean) => void;
    toggleSidebarCollapsed: () => void;
    sidebarMode: SidebarLayoutMode;
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
};

const AppShellContext = React.createContext<AppShellContextValue | null>(null);

export function useAppShell() {
    const context = React.useContext(AppShellContext);
    if (!context) {
        throw new Error("useAppShell must be used within AppShell");
    }
    return context;
}

/** Safe variant for components that may render outside AppShell */
export function useAppShellOptional() {
    return React.useContext(AppShellContext);
}

export { AppShellContext };
